import ObjectSelectionStepShared from "../common/components/ObjectSelectionStep/ObjectSelectionStepShared";
import { useObjectFirstEntry } from "../common/hooks/useObjectFirstEntry";
import { useFetchVenues } from "../../../redux/flows/fetchVenuesFlow";
import { useEventFlowUseCase } from "./eventFlowUseCase";

/** The category notice of the flow's own use case (venue, hall). */
const categoryNoticeKeys = (useCase: string) => ({
  showAll: `book_location.category_notice.${useCase}.show_all`,
  unknown: `book_location.category_notice.${useCase}.unknown`,
});

/**
 * Venue object selection — the shared step, configured (ADR-0026, phase 1
 * step 5).
 *
 * `fetch_venues`, not `fetch_apartments`: the room wording ("Die verfügbaren
 * Zimmer …") is wrong on a venue search (#2767).
 *
 * This flow does NOT pass `reselectLocationOnPick`, matching what it has
 * always done. Whether that is a gap is being measured as #2764 E14 rather
 * than guessed at here.
 */
function ApartmentSelectionStep() {
  const useCase = useEventFlowUseCase();
  const searchAgain = useFetchVenues(useCase);
  // #3035: object-first narrows the dated result to the room already picked.
  const { pickedObjectId, pickedRoom } = useObjectFirstEntry(useCase);
  const capacity = Number(pickedRoom?.accomodationdetail?.guests);
  return (
    <ObjectSelectionStepShared
      errorMessageKey={`book_location.error.fetch_${useCase}s`}
      categoryNoticeKeys={categoryNoticeKeys(useCase)}
      searchAgain={searchAgain}
      onlyObjectId={pickedObjectId}
      onlyObjectCapacity={Number.isInteger(capacity) && capacity > 0 ? capacity : null}
    />
  );
}

export default ApartmentSelectionStep;
